import type { OpenWorkTabAreaMark as AreaMark } from '../plugin-system/offer.ts';

export default function OpenWorkTabAreaMark({
  mark,
  hasMenu = false,
}: {
  mark: AreaMark;
  hasMenu?: boolean;
}) {
  const firstLetter = mark.monogram.slice(0, 1);
  const remainingLetters = mark.monogram.slice(1);

  return (
    <span aria-hidden="true" className="app-open-work-tab-area-mark" data-tone={mark.tone}>
      <span className="app-open-work-tab-area-mark__first-letter">
        {firstLetter}
        {hasMenu && <span className="app-open-work-tab-area-mark__menu-caret" />}
      </span>
      {remainingLetters}
    </span>
  );
}
